import store from "@store";

export const helper = {
  callDownload: data => {
    if (data) {
      var base64 = data.content;
      const binaryString = window.atob(base64);
      const bytes = new Uint8Array(binaryString.length);
      const byteArray = bytes.map((byte, i) => binaryString.charCodeAt(i));
      const url = window.URL.createObjectURL(
        new Blob([byteArray], {
          type: data.contentType
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", data.fileName);
      document.body.appendChild(link);
      link.click();
    }
  },
  openModal: () => {
    store.dispatch("modal/show");
    store.dispatch("alert/clear");
  },
  closeModal: () => {
    store.dispatch("modal/clear");
    store.dispatch("alert/clear");
  },
  setLabelRequired: () => {
    document.querySelectorAll("input:required").forEach(function(element) {
      element.parentElement.parentElement
        .querySelector("label")
        .classList.add("label-required");
    });
    document.querySelectorAll("select:required").forEach(function(element) {
      element.parentElement.parentElement
        .querySelector("label")
        .classList.add("label-required");
    });
    document
      .querySelectorAll(".b-form-datepicker[aria-required='true']")
      .forEach(function(element) {
        element.parentElement.parentElement
          .querySelector("label")
          .classList.add("label-required");
      });
  }
};
